import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IProduitCategorie from '../../models/IProduitCategorie';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionProduitCategorieProps {
  isModeSelection?: boolean;
}

class ProduitCategorie extends IBaseModel implements IProduitCategorie {
  idProduitCategorie: Guid = Guid.empty;
  actif: boolean = false;
}

export default function GestionProduitCategorie({ isModeSelection }: IGestionProduitCategorieProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="ProduitCategorie" model={ProduitCategorie} />
  );
}